<template>
  <a
      :href="`${$publicPath}filestorage/${file.relativeUri}`"
      :download="file.name"
  >
    <img src="../../assets/svg/file.svg" alt="файл"/>{{ file.name }}
    <small class="has-text-grey">{{ file.size | sizeToKb }} </small>
  </a>
</template>
<script>
export default {
  props: {
    file: {
      type: Object,
      required: true,
    },
  },
};
</script>
<style scoped lang="scss">
img {
  margin: 5px 6px 0 0;
}

.has-text-grey {
  white-space: nowrap;
}
</style>
